var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeadingAttend = function SvgHeadingAttend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.621 47.767"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 84",
    d: "M35.484 12.111a15.774 15.774 0 0 1 1.609 19.292c-3.438 5.506-8.205 13.262-13.31 13.384-5.952.14-7.351-5.015-12.523-11.619-5.462-6.975-5.105-16.825 1.584-22.64a16.048 16.048 0 0 1 22.64 1.583",
    fill: "currentColor"
  })));
};
export default SvgHeadingAttend;